import { translateMetadata } from '@/utils';
import { guards, type ILearningObjectInstanceResponse, type IncludedType, type LoInstanceStateType } from '@/services';
import { type IInstanceData, InstanceStateTypes } from '@/entities';
import { mapPrimeModule } from '@/mappers/module';

export const mapPrimeInstance = (data: ILearningObjectInstanceResponse, included?: IncludedType[]): IInstanceData => {
  const subLearningObjectInstances = data.relationships?.subLoInstances?.data
    .map(
      (item) =>
        included?.filter(guards.isInstance).find((loI) => loI.id === item.id) || ({} as ILearningObjectInstanceResponse)
    )
    .filter((item) => {
      if (item.id) return item;
    });
  const learningObjectResources = included
    ?.filter(guards.isResource)
    .filter((lor) => lor.relationships?.loInstance?.data.id === data.id);
  const ids = data.relationships?.loResources?.data.map((lor) => lor.id);
  if (ids && learningObjectResources) learningObjectResources.sort((a, b) => ids.indexOf(a.id) - ids.indexOf(b.id));

  return {
    id: data.id,
    learningObjectId: data.relationships?.learningObject?.data.id,
    name: translateMetadata(data.attributes?.localizedMetadata)?.name || '',
    dateCreated: data.attributes.dateCreated,
    isDefault: data.attributes.isDefault,
    isFlexible: data.attributes.isFlexible,
    completionDeadline: data.attributes.completionDeadline || '',
    enrollmentDeadline: data.attributes.enrollmentDeadline || '',
    state: toInstanceStateType(data.attributes.state),
    modules: learningObjectResources?.map((l) => mapPrimeModule(l, included)) || [],
    subInstances: subLearningObjectInstances?.map((item) => mapPrimeInstance(item, included))
  };
};

const toInstanceStateType = (state: LoInstanceStateType | undefined): InstanceStateTypes => {
  if (state == 'Retired') return InstanceStateTypes.Retired;
  return InstanceStateTypes.Active;
};
